<template>
<div class="con">授权已完成，请关闭此页面</div>
</template>
<script>
export default {
  data () {
    return {
      param: {}
    }
  },
  mounted () {
    this.oeCallBack()
  },
  methods: {
    oeCallBack () {
      this.param = {
        'state': this.$route.query.state,
        'auth_code': this.$route.query.auth_code
      }
      let url = '/api/account/employee/oeCallBack'
      if (this.$route.path.startsWith('/qianchuan')) {
        url += '/qc'
      }
      this.$service.post(url, this.param).then(res => {
        // console.log(res)
      }).catch(Err => {
      })
    }
  }

}
</script>
<style lang="less" scoped>
    .con{
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 100%;
      text-align: center;
      line-height: 50px;
      height: 50px;
      font-size: 16px;
    }

</style>



// WEBPACK FOOTER //
// src/views/accountManage/authCallback.vue